import React, { useState, useEffect, useRef } from 'react';

const ComboBoxComponent = ({
  onChange,
  dataSource,
  value,
  placeholder,
  showCloseButton = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);


  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="position-relative combobox-wrapper" ref={wrapperRef}>
      <div className="d-flex align-items-center rounded-3 px-2 input-wrapper">
        <input
          type="text"
          value={value?.name || ""}
          className="flex-grow-1 border-0 focus-outline-none"
          placeholder={placeholder}
          onClick={() => setIsOpen(!isOpen)}
          readOnly
        />
        {value?.name && showCloseButton && (
          <div className="border-0 bg-transparent combobox-close-icon" onClick={() => onChange("")}>
            <i className={`lf-icon lf-icon-close`}/>
          </div>
        )}
        <div className="border-0 bg-transparent combobox-arrow-icon" onClick={() => setIsOpen(!isOpen)}>
          <i className={`lf-icon lf-icon-angle-${isOpen ? "up" : "down"}`}/>
        </div>

      </div>
      {isOpen && (
        <ul className="position-absolute z-10 bg-white rounded-3 w-100 mt-2 max-h-64 overflow-y-auto">
          {dataSource.map(option => (
            <li
              key={option.name}
              className="px-3 py-2 hover-bg-gray-100 cursor-pointer"
              onClick={() => {
                setIsOpen(false);
                onChange(option.name);
              }}
            >
              {option.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ComboBoxComponent;
